<template>
    <details
        :open="isOpen"
        class="tw:group tw:bg-white tw:rounded-lg tw:shadow tw:overflow-hidden"
    >
        <summary
            class="tw:flex tw:items-center tw:justify-between tw:p-2 tw:cursor-pointer"
            @click.prevent="onToggleClick"
        >
            <div class="tw:flex tw:items-center tw:gap-2 tw:sm:gap-4">
                <slot name="summaryIcon"></slot>
                <slot name="summaryContent"></slot>
            </div>
            <div class="tw:flex tw:items-center tw:gap-1 tw:sm:gap-2">
                <slot name="summaryActions"></slot>
                <i class="material-icons tw:text-slate-400 tw:transition-transform tw:duration-500 tw:ease-in-out tw:group-open:rotate-180">keyboard_arrow_down</i>
            </div>
        </summary>

        <div class="tw:p-2 tw:md:p-4">
            <div class="tw:h-px tw:bg-slate-100 tw:mb-5"></div>
            <slot></slot>
        </div>
    </details>
</template>
<script setup>
    import { ref } from 'vue';

    const props = defineProps({
        expandId: {
            type: [String, Number],
            required: true,
        },
    });

    const emit = defineEmits(['expand']);

    const isOpen = ref(false);

    const onToggleClick = () => {
        if (!isOpen.value) {
            emit('expand', props.expandId);
        }
        isOpen.value = !isOpen.value;
    };
</script>
